// import "../../Notifications.css";

import React, {useState, useEffect} from "react";
import {sweetAlertQuestion, sweetAlerts} from "../../utils/sweet-alerts";
import {getNotificationsList, readNotification, deleteNotification} from "../../services/adminServices";
import {Drawer} from "antd";
import moment from "moment";
import {fDateTime, fTimeAgo} from "../../utils/format-time";
import Avatar from "@mui/material/Avatar";
import CustomUserName from "../../CustomComponents/CustomUserName";
import CustomRatingStar from "../../CustomComponents/CustomRatingStar";
import {issueLabels} from "../../constant";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Notifications = () => {
	const [apiFlag, setApiFlag] = useState(true);
	const [notifications, setNotifications] = useState([]);
	const [notificationsList, setNotificationsList] = useState([]);
	const [filteredNotifications, setFilteredNotifications] = useState([]);
	const [loading, setLoading] = useState(true);
	const [activeFilter, setActiveFilter] = useState("all");
	const [showOnlyUnread, setShowOnlyUnread] = useState(false);
	const [showReviewModal, setShowReviewModal] = useState(false);
	const [showAppealModal, setShowAppealModal] = useState(false);
	const [selectedNotification, setSelectedNotification] = useState(null);
	const [showDetailModal, setShowDetailModal] = useState(false);
	const [appealForm, setAppealForm] = useState({
		firstName: "John",
		lastName: "Doe",
		email: "john.doe@example.com",
		phoneNumber: "+1 (555) 123-4567",
		companyName: "ABC Construction Co.",
		message: "",
	});

	const [open, setOpen] = useState(false);

	useEffect(() => {
		try {
			getNotificationsList({
				unread: showOnlyUnread,
				action: activeFilter,
			})
				.then((res) => {
					if (res.status) {
						setNotificationsList(res.data);
					}
				})
				.catch((error) => {
					console.error("Error fetching notifications:", error);
				});
		} catch (error) {
			console.error("Error fetching notifications:", error);
		}
	}, [apiFlag, showOnlyUnread, activeFilter]);

	useEffect(() => {
		// Apply filters
		let filtered = notifications;

		// Filter by type
		if (activeFilter !== "all") {
			filtered = filtered.filter((notification) => notification.type === activeFilter);
		}

		// Filter by read status
		if (showOnlyUnread) {
			filtered = filtered.filter((notification) => !notification.isRead);
		}

		setFilteredNotifications(filtered);
	}, [notifications]);

	const markAsRead = async (id) => {
		try {
			const response = await readNotification({notification_id: id});
			if (response.status) {
				setApiFlag(!apiFlag);
				sweetAlerts("success", "Notification marked as read");

				// Dispatch custom event to update notification count in header
				window.dispatchEvent(new CustomEvent("notificationCountUpdate"));
			} else {
				sweetAlerts("error", "Failed to mark notification as read");
			}
		} catch (error) {
			console.error("Error marking notification as read:", error);
			sweetAlerts("error", "An error occurred while marking notification as read");
		}
	};

	const markAllAsRead = async () => {
		try {
			const response = await readNotification({all: true});
			if (response.status) {
				setApiFlag(!apiFlag);
				sweetAlerts("success", "All notifications marked as read");

				// Dispatch custom event to update notification count in header
				window.dispatchEvent(new CustomEvent("notificationCountUpdate"));
			} else {
				sweetAlerts("error", "Failed to mark all notifications as read");
			}
		} catch (error) {
			console.error("Error marking all notifications as read:", error);
			sweetAlerts("error", "An error occurred while marking all notifications as read");
		}
	};

	const handleDeleteNotification = async (id) => {
		try {
			const response = await deleteNotification({notification_id: id});
			if (response.status) {
				setApiFlag(!apiFlag);
				// Close drawer if the deleted notification is currently selected
				if (selectedNotification && selectedNotification.notification_id === id) {
					setOpen(false);
					setSelectedNotification(null);
				}
				sweetAlerts("success", "Notification deleted successfully");
			} else {
				sweetAlerts("error", "Failed to delete notification");
			}
		} catch (error) {
			console.error("Error deleting notification:", error);
			sweetAlerts("error", "An error occurred while deleting notification");
		}
	};

	const handleAction = (notification, action) => {
		// Handle different action types
		switch (action.type) {
			case "review":
				setSelectedNotification(notification);
				setShowReviewModal(true);
				break;
			case "appeal":
				setSelectedNotification(notification);
				setShowAppealModal(true);
				break;
			default:
		}

		// Mark as read when action is taken
		markAsRead(notification.id);
	};

	const handleAppealSubmit = (e) => {
		e.preventDefault();
		sweetAlerts("success", "Appeal submitted successfully!");
		setShowAppealModal(false);
		setAppealForm((prev) => ({...prev, message: ""}));
	};

	const getNotificationIcon = (type) => {
		switch (type) {
			case "rating_flagged":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M10.29 3.86L1.82 18A2 2 0 003.64 21H20.36A2 2 0 0022.18 18L13.71 3.86A2 2 0 0010.29 3.86Z" stroke="currentColor" strokeWidth="2" />
						<path d="M12 9V13" stroke="currentColor" strokeWidth="2" />
						<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "account_warning":
			case "account_suspension":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
						<path d="M15 9L9 15" stroke="currentColor" strokeWidth="2" />
						<path d="M9 9L15 15" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "rating_approved":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M22 11.08V12A10 10 0 1112 2A10 10 0 0122 11.08Z" stroke="currentColor" strokeWidth="2" />
						<path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "system_update":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M21 16V8A2 2 0 0019 6H5A2 2 0 003 8V16A2 2 0 005 18H19A2 2 0 0021 16Z" stroke="currentColor" strokeWidth="2" />
						<path d="M7 2V6" stroke="currentColor" strokeWidth="2" />
						<path d="M17 2V6" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "rating_edited":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M11 4H4A2 2 0 002 6V20A2 2 0 004 22H18A2 2 0 0020 20V13" stroke="currentColor" strokeWidth="2" />
						<path d="M18.5 2.5A2.121 2.121 0 0121 5L12 14L8 15L9 11L18.5 2.5Z" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "recommendation_request":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M14 9V5A3 3 0 0011 2H2V21H11A3 3 0 0014 18V14" stroke="currentColor" strokeWidth="2" />
						<path d="M14 14L18 18L22 14" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "maintenance":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M14.7 6.3A1 1 0 000 5L1.4 3.6A1 1 0 002.8 3.6L4.2 5A1 1 0 005.6 3.6L7 5A1 1 0 008.4 3.6L9.8 5A1 1 0 0011.2 3.6L12.6 5A1 1 0 0014 3.6L15.4 5A1 1 0 0016.8 3.6L18.2 5A1 1 0 0019.6 3.6L21 5A1 1 0 0022.4 6.4L21 7.8A1 1 0 0019.6 9.2L18.2 7.8A1 1 0 0016.8 9.2L15.4 7.8A1 1 0 0014 9.2L12.6 7.8A1 1 0 0011.2 9.2L9.8 7.8A1 1 0 008.4 9.2L7 7.8A1 1 0 005.6 9.2L4.2 7.8A1 1 0 002.8 9.2L1.4 7.8A1 1 0 000 6.4L1.4 5A1 1 0 002.8 6.4L4.2 8A1 1 0 005.6 6.4L7 8A1 1 0 008.4 6.4L9.8 8A1 1 0 0011.2 6.4L12.6 8A1 1 0 0014 6.4L14.7 6.3Z"
							stroke="currentColor"
							strokeWidth="2"
						/>
					</svg>
				);
			case "new":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M22 11.08V12A10 10 0 1112 2A10 10 0 0122 11.08Z" stroke="currentColor" strokeWidth="2" />
						<path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "update":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M11 4H4A2 2 0 002 6V20A2 2 0 004 22H18A2 2 0 0020 20V13" stroke="currentColor" strokeWidth="2" />
						<path d="M18.5 2.5A2.121 2.121 0 0121 5L12 14L8 15L9 11L18.5 2.5Z" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "delete":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
						<path d="M15 9L9 15" stroke="currentColor" strokeWidth="2" />
						<path d="M9 9L15 15" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
			case "like":
				return (
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<g fill="none">
							<path
								fill="currentColor"
								d="m15 10l-.74-.123a.75.75 0 0 0 .74.873zM4 10v-.75a.75.75 0 0 0-.75.75zm16.522 2.392l.735.147zM6 20.75h11.36v-1.5H6zm12.56-11.5H15v1.5h3.56zm-2.82.873l.806-4.835l-1.48-.247l-.806 4.836zm-.92-6.873h-.214v1.5h.213zm-3.335 1.67L8.97 8.693l1.248.832l2.515-3.773zM7.93 9.25H4v1.5h3.93zM3.25 10v8h1.5v-8zm16.807 8.54l1.2-6l-1.47-.295l-1.2 6zM8.97 8.692a1.25 1.25 0 0 1-1.04.557v1.5c.92 0 1.778-.46 2.288-1.225zm7.576-3.405A1.75 1.75 0 0 0 14.82 3.25v1.5a.25.25 0 0 1 .246.291zm2.014 5.462c.79 0 1.38.722 1.226 1.495l1.471.294A2.75 2.75 0 0 0 18.56 9.25zm-1.2 10a2.75 2.75 0 0 0 2.697-2.21l-1.47-.295a1.25 1.25 0 0 1-1.227 1.005zm-2.754-17.5a3.75 3.75 0 0 0-3.12 1.67l1.247.832a2.25 2.25 0 0 1 1.873-1.002zM6 19.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 6 20.75z"
							/>
							<path stroke="currentColor" strokeWidth="1.5" d="M8 10v10" />
						</g>
					</svg>
				);
			case "unlike":
				return (
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<g fill="none">
							<path
								fill="currentColor"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								d="m15 14l-.493.082A.5.5 0 0 1 15 13.5zM4 14v.5a.5.5 0 0 1-.5-.5zm16.522-2.392l.49-.098zM6 3.5h11.36v1H6zm12.56 11H15v-1h3.56zm-3.067-.582l.806 4.835l-.986.165l-.806-4.836zM14.82 20.5h-.213v-1h.213zm-3.126-1.558l-2.515-3.774l.832-.555l2.515 3.774zM7.93 14.5H4v-1h3.93zM3.5 14V6h1v8zm16.312-8.49l1.2 6l-.98.196l-1.2-6zM9.178 15.168A1.5 1.5 0 0 0 7.93 14.5v-1a2.5 2.5 0 0 1 2.08 1.113zm7.121 3.585a1.5 1.5 0 0 1-1.48 1.747v-1a.5.5 0 0 0 .494-.582zM18.56 13.5a1.5 1.5 0 0 0 1.471-1.794l.98-.196a2.5 2.5 0 0 1-2.45 2.99zm-1.2-10a2.5 2.5 0 0 1 2.452 2.01l-.98.196A1.5 1.5 0 0 0 17.36 4.5zm-2.754 17a3.5 3.5 0 0 1-2.913-1.558l.832-.555a2.5 2.5 0 0 0 2.08 1.113zM6 4.5A1.5 1.5 0 0 0 4.5 6h-1A2.5 2.5 0 0 1 6 3.5z"
							/>
							<path stroke="currentColor" d="M8 14V4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</g>
					</svg>
				);
			case "uplift":
				return (
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				);
			case "unflag":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.29 3.86L1.82 18C1.64 18.37 1.54 18.78 1.54 19.2C1.54 19.62 1.64 20.03 1.82 20.4C2 20.77 2.26 21.09 2.59 21.33C2.92 21.57 3.31 21.73 3.72 21.8C4.13 21.87 4.55 21.85 4.95 21.75C5.35 21.65 5.72 21.47 6.04 21.22L12 17.27L17.96 21.22C18.28 21.47 18.65 21.65 19.05 21.75C19.45 21.85 19.87 21.87 20.28 21.8C20.69 21.73 21.08 21.57 21.41 21.33C21.74 21.09 22 20.77 22.18 20.4C22.36 20.03 22.46 19.62 22.46 19.2C22.46 18.78 22.36 18.37 22.18 18L13.71 3.86C13.53 3.49 13.27 3.17 12.94 2.93C12.61 2.69 12.22 2.53 11.81 2.46C11.4 2.39 10.98 2.41 10.58 2.51C10.18 2.61 9.81 2.79 9.49 3.04C9.17 3.29 8.91 3.61 8.73 3.98C8.55 4.35 8.45 4.76 8.45 5.18C8.45 5.6 8.55 6.01 8.73 6.38L10.29 3.86Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path d="M12 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				);
			case "flag":
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.29 3.86L1.82 18C1.64 18.37 1.54 18.78 1.54 19.2C1.54 19.62 1.64 20.03 1.82 20.4C2 20.77 2.26 21.09 2.59 21.33C2.92 21.57 3.31 21.73 3.72 21.8C4.13 21.87 4.55 21.85 4.95 21.75C5.35 21.65 5.72 21.47 6.04 21.22L12 17.27L17.96 21.22C18.28 21.47 18.65 21.65 19.05 21.75C19.45 21.85 19.87 21.87 20.28 21.8C20.69 21.73 21.08 21.57 21.41 21.33C21.74 21.09 22 20.77 22.18 20.4C22.36 20.03 22.46 19.62 22.46 19.2C22.46 18.78 22.36 18.37 22.18 18L13.71 3.86C13.53 3.49 13.27 3.17 12.94 2.93C12.61 2.69 12.22 2.53 11.81 2.46C11.4 2.39 10.98 2.41 10.58 2.51C10.18 2.61 9.81 2.79 9.49 3.04C9.17 3.29 8.91 3.61 8.73 3.98C8.55 4.35 8.45 4.76 8.45 5.18C8.45 5.6 8.55 6.01 8.73 6.38L10.29 3.86Z"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path d="M12 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				);
			default:
				return (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
						<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
						<path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" />
					</svg>
				);
		}
	};

	const getPriorityColor = (priority) => {
		switch (priority) {
			case "urgent":
				return "priority-urgent";
			case "high":
				return "priority-high";
			case "medium":
				return "priority-medium";
			case "low":
				return "priority-low";
			default:
				return "priority-medium";
		}
	};

	const getTypeColor = (type) => {
		switch (type) {
			case "rating_flagged":
				return "type-warning";
			case "account_warning":
				return "type-danger";
			case "account_suspension":
				return "type-danger";
			case "rating_approved":
				return "type-success";
			case "system_update":
				return "type-info";
			case "rating_edited":
				return "type-warning";
			case "recommendation_request":
				return "type-primary";
			case "maintenance":
				return "type-secondary";
			case "new":
				return "type-success";
			case "update":
				return "type-warning";
			case "delete":
				return "type-danger";
			case "like":
				return "type-success";
			case "unlike":
				return "type-warning";
			case "uplift":
				return "type-secondary";
			case "flag":
				return "type-warning";
			case "unflag":
				return "type-success";
			default:
				return "type-secondary";
		}
	};

	const getBootstrapBadgeClass = (type) => {
		const typeColor = getTypeColor(type);
		switch (typeColor) {
			case "type-success":
				return "bg-success";
			case "type-warning":
				return "bg-warning text-dark";
			case "type-danger":
				return "bg-danger";
			case "type-info":
				return "bg-info text-dark";
			case "type-primary":
				return "bg-primary";
			case "type-secondary":
			default:
				return "bg-secondary";
		}
	};

	const formatTimestamp = (timestamp) => {
		const date = new Date(timestamp);
		const now = new Date();
		const diffInMinutes = Math.floor((now - date) / (1000 * 60));

		if (diffInMinutes < 1) return "Just now";
		if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
		if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
		if (diffInMinutes < 10080) return `${Math.floor(diffInMinutes / 1440)}d ago`;

		return date.toLocaleDateString();
	};

	const getUnreadCount = () => {
		return notificationsList.filter((n) => !n.is_read).length;
	};

	const getFilterOptions = () => {
		// const types = [...new Set(notificationsList.map((n) => n.type))];
		return [
			{value: "all", label: "All Notifications"},
			{value: "flagged", label: "Flagged"},
			// {value: "account_warning", label: "Account Warnings"},
			// {value: "account_suspension", label: "Suspensions"},
			// {value: "rating_approved", label: "Approved Ratings"},
			// {value: "system_update", label: "System Updates"},
			{value: "likes", label: "Like"},
			{value: "rating", label: "Rating"},
			{value: "addresses", label: "Address"},
			// {value: "recommendation_request", label: "Recommendation Requests"},
			// {value: "maintenance", label: "Maintenance"},
		];
	};

	const formatDetailsValue = (key, value) => {
		if (value === null || value === undefined) return null;

		// Handle dates
		if (key.includes("date") || key.includes("Date") || key.includes("At") || key === "createdAt" || key === "updatedAt") {
			try {
				return new Date(value).toLocaleString();
			} catch (e) {
				return String(value);
			}
		}

		// Handle arrays
		if (Array.isArray(value)) {
			if (key === "job_issues") {
				return value.map((v) => String(v).replace(/-/g, " ")).join(", ");
			}
			return value.join(", ");
		}

		// Handle objects
		if (typeof value === "object") {
			return JSON.stringify(value, null, 2);
		}

		// Handle booleans
		if (typeof value === "boolean") {
			return value ? "Yes" : "No";
		}

		// Handle numeric booleans
		if (key === "verified" || key === "is_active" || key === "is_historic" || key === "deleted") {
			return value === 1 || value === "1" || value === true ? "Yes" : "No";
		}

		return String(value);
	};

	const getDetailsLabel = (key) => {
		const labelMap = {
			// Rating fields
			rating_id: "Rating ID",
			stars: "Stars",
			job_date: "Job Date",
			job_performed: "Job Performed",
			job_issues: "Job Issues",
			description: "Description",
			client_name: "Client Name",
			recommendation: "Recommendation",
			parent_uplift_id: "Parent Uplift ID",
			uplift: "Uplift",
			// Comment fields
			street_id: "Street ID",
			parent_street_id: "Parent Street ID",
			addresses_id: "Address ID",
			addresses: "Address",
			comment_date: "Comment Date",
			first_time_date: "First Time Date",
			comment_type: "Comment Type",
			// Address fields
			full_address: "Full Address",
			place_id: "Place ID",
			zip_code: "Zip Code",
			city: "City",
			state: "State",
			country: "Country",
			aggregate_rating: "Aggregate Rating",
			total_ratings: "Total Ratings",
			active_ratings: "Active Ratings",
			issue_summary: "Issue Summary",
			manual_id: "Manual ID",
			// Like fields
			log_id: "Log ID",
			model: "Model",
			action: "Action",
			record_id: "Record ID",
			changes: "Changes",
			ip_address: "IP Address",
			// User fields
			user_id: "User ID",
			first_name: "First Name",
			last_name: "Last Name",
			business_name: "Business Name",
			email: "Email",
			role: "Role",
			status: "Status",
			verified: "Verified",
			is_flagged: "Is Flagged",
			is_suspended: "Is Suspended",
			// Common fields
			is_active: "Is Active",
			is_historic: "Is Historic",
			deleted: "Deleted",
			delete_at: "Deleted At",
			createdAt: "Created At",
			updatedAt: "Updated At",
			admin_flagged: "Admin Flagged",
			admin_edited: "Admin Edited",
			admin_blocked: "Admin Blocked",
		};

		return labelMap[key] || key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
	};

	const renderDetailsSection = (details, table) => {
		if (!details || typeof details !== "object") return null;

		// Keys to exclude from display
		const excludeKeys = [
			"is_active",
			"admin_flagged",
			"admin_edited",
			"admin_blocked",
			"uplift",
			"deleted",
			"is_historic",
			"createdAt",
			"updatedAt",
			"rating_id",
			"addresses_id",
			"user_id",
			"street_id",
			"parent_street_id",
			"parent_uplift_id",
			"log_id",
			"manual_id",
			"place_id",
			"delete_at",
			"comment_type",
			"changes",
			"model",
			"action",
			"ip_address",
			"record_id",
		];

		// Group fields by category
		const categories = {
			basic: [],
			rating: [],
			comment: [],
			address: [],
			user: [],
			system: [],
		};

		Object.entries(details).forEach(([key, value]) => {
			// Skip excluded keys and null/undefined values
			if (excludeKeys.includes(key) || value === null || value === undefined) return;

			if (key.includes("rating") || key.includes("job") || key.includes("stars") || key.includes("client")) {
				categories.rating.push([key, value]);
			} else if (key.includes("comment") || key.includes("street") || key.includes("description")) {
				categories.comment.push([key, value]);
			} else if (key.includes("address") || key.includes("place") || key.includes("city") || key.includes("state") || key.includes("country") || key.includes("zip")) {
				categories.address.push([key, value]);
			} else if (key.includes("user") || key.includes("name") || key.includes("email") || key.includes("business")) {
				categories.user.push([key, value]);
			} else if (key.includes("log") || key.includes("model") || key.includes("action") || key.includes("changes") || key.includes("ip")) {
				categories.system.push([key, value]);
			} else {
				categories.basic.push([key, value]);
			}
		});

		const categoryLabels = {
			rating: "Rating Information",
			comment: "Comment Information",
			address: "Address Information",
			user: "User Information",
			system: "System Information",
			basic: "Additional Information",
		};

		return (
			<div>
				{Object.entries(categories).map(([category, items]) => {
					if (items.length === 0) return null;
					return (
						<div key={category} className="mb-4">
							<h6 className="mb-3" style={{fontSize: "1rem", fontWeight: 600, color: "#495057", paddingBottom: "0.75rem", borderBottom: "1px solid #e9ecef"}}>
								{categoryLabels[category]}
							</h6>
							<div className="row g-3">
								{items.map(([key, value]) => {
									const formattedValue = formatDetailsValue(key, value);
									if (formattedValue === null) return null;
									return (
										<div key={key} className="col-md-6">
											<div className="p-3 bg-light rounded border">
												<small className="text-muted d-block mb-1" style={{fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600}}>
													{getDetailsLabel(key)}
												</small>
												<div style={{fontSize: "0.95rem", color: "#2c3e50", fontWeight: 500, wordBreak: "break-word"}}>{formattedValue}</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	const ObjectString = ({recode_data}) => {
		const relatedData = JSON.parse(recode_data);

		let relatedDataGet;

		if (typeof recode_data === "string") {
			try {
				const start = recode_data.indexOf('"');
				const end = recode_data.lastIndexOf('"') + 1;
				const jsonString = recode_data.slice(start, end);
				relatedDataGet = JSON.parse(jsonString);
			} catch (err) {
				relatedDataGet = {};
			}
		} else if (typeof recode_data === "object" && recode_data !== null) {
			relatedDataGet = recode_data;
		} else {
			relatedDataGet = {};
		}

		// Ensure relatedData is an object
		// const relatedData = typeof relatedDataGet === "string" ? JSON.parse(relatedDataGet) : relatedDataGet;

		// Keys you want to exclude
		const excludeKeys = [
			"is_active",
			"admin_flagged",
			"admin_edited",
			"admin_blocked",
			"uplift",
			"deleted",
			"is_historic",
			"createdAt",
			"updatedAt",
			"rating_id",
			"client_name",
			"addresses_id",
			"user_id",
			"job_date",
			"total_ratings",
			"active_ratings",
			"zip_code",
			"city",
			"state",
			"country",
			"manual_id",
		];

		// Mapping keys to readable labels
		const labelMap = {
			stars: "Stars",
			job_issues: "Issues",
			client_name: "Client Name",
			job_date: "Job Date",
			createdAt: "Created At",
			updatedAt: "Updated At",
			full_address: "Address",
			aggregate_rating: "Aggregate Rating",
			description: "Description",
			comment_date: "Comment Date",
			addresses: "Addresses",
			first_name: "First Name",
			last_name: "last Name",
			business_name: "business Name",
			verified: "Verified",
		};

		return (
			<div className="detail-container">
				{Object.entries(relatedData)
					.filter(([key, value]) => !excludeKeys.includes(key) && labelMap[key] && value !== null && value !== undefined) // only show keys that exist in labelMap and have non-null values
					.map(([key, value]) => (
						<div className="detail-item" key={key}>
							<strong>{labelMap[key]}:</strong>{" "}
							{key === "job_issues"
								? (() => {
										// Handle job_issues specifically - it might be a string array or actual array
										let issuesArray = value;
										if (typeof value === "string") {
											try {
												issuesArray = JSON.parse(value);
											} catch (e) {
												issuesArray = [value];
											}
										}
										return Array.isArray(issuesArray) ? issuesArray.map((v) => v.replace(/-/g, " ")).join(", ") : String(value);
									})()
								: key === "verified"
									? value === 1 || value === "1" || value === true
										? "Verified"
										: "Not Verified"
									: Array.isArray(value)
										? value.join(", ")
										: String(value)}
						</div>
					))}
			</div>
		);
	};

	const showDrawer = (notification) => {
		setSelectedNotification(notification);
		setOpen(true);
		// Mark as read when viewing details
		if (notification && !notification.is_read) {
			markAsRead(notification.notification_id);
		}
	};

	const handleViewDetails = (notification) => {
		setSelectedNotification(notification);
		setShowDetailModal(true);
		// Mark as read when viewing details
		if (notification && !notification.is_read) {
			markAsRead(notification.notification_id);
		}
	};

	const onClose = () => {
		setOpen(false);
		setSelectedNotification(null);
	};

	const formatDateTime = (dateString) => {
		if (!dateString) return "N/A";
		return new Date(dateString).toLocaleString("en-US", {
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});
	};

	const renderLikeNotificationContent = (notification) => {
		if (!notification?.details) {
			return (
				<div className="no-ratings" style={{padding: "32px 0"}}>
					<h3>Rating details not available</h3>
					<p>This like does not have enough data to display.</p>
				</div>
			);
		}

		const details = notification.details;
		const isRating = Boolean(details.rating_id);
		const address = details?.address?.full_address || details?.full_address || details?.addresses || "Address not available";
		const description = details?.description || "";
		const jobIssues = Array.isArray(details?.job_issues) ? details.job_issues : [];
		const stars = details?.stars ? Number(details.stars) : null;
		const likedAt = notification?.createdAt;
		const tableBy = notification?.table === "street_comment";
		const likedBy = notification?.sent_by_user;

		const renderCommentTypeBadge = (commentType) => {
			if (commentType === undefined) return null;
			return commentType ? <span className="badge badge-success">📍 Zipcode</span> : <span className="badge badge-warning">🏘️ Street</span>;
		};

		return (
			<div className="ratings-grid" style={{marginTop: 0}}>
				<div className="rating-card">
					<div className="rating-card-header">
						<div className="address-info">
							<h4 className={isRating ? "job-address" : "comment-address"}>{address}</h4>
							<div className="rating-info">
								<div className="item-type-badge">
									{isRating ? (
										<>
											<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
												<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" />
											</svg>
											<span>Rating</span>
										</>
									) : (
										<>
											<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
												<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" />
											</svg>
											<span>Comment</span>
										</>
									)}
								</div>
								{!isRating && renderCommentTypeBadge(details?.comment_type)}
							</div>
						</div>
					</div>

					<div className="rating-card-body">
						{isRating && stars && (
							<div className="rating-display">
								<div className={`rating-stars ${stars >= 4 ? "rating-excellent" : stars >= 3 ? "rating-good" : stars >= 2 ? "rating-fair" : "rating-poor"}`}>
									{[...Array(5)].map((_, index) => (
										<span key={index} className={`star ${index < stars ? "filled" : ""}`}>
											★
										</span>
									))}
									<span className="rating-number">({stars}/5)</span>
								</div>
								{jobIssues.length > 0 && (
									<div className="issues-list">
										{jobIssues.slice(0, 2).map((issue, index) => (
											<span key={index} className="issue-tag">
												{issueLabels[issue] || issue.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
											</span>
										))}
										{jobIssues.length > 2 && <span className="issue-tag more">+{jobIssues.length - 2} more</span>}
									</div>
								)}
							</div>
						)}

						{description && (
							<div className="comment-description">
								<p>{description.length > 160 ? `${description.substring(0, 160)}...` : description}</p>
							</div>
						)}
					</div>

					<div className="rating-card-footer ">
						<div className="footer-left ">
							<div className="meta-item">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none">
									<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
									<polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" />
								</svg>
								<span>{fDateTime(likedAt)}</span>
							</div>
						</div>
						<div className="footer-right">
							<div className="meta-item more back-btn justify-content-end " style={{fontSize: 13, color: "#000"}}>
								<div className="bi-hand-thumbs-up" style={{fontSize: 16}} />
								Liked by,
								{likedBy ? (
									// <CustomUserName user={likedBy} code={Boolean(isRating)} sx={{fontSize: 13, color: "#000", fontWeight: 600}} />
									<CustomUserName user={likedBy} code={!tableBy} sx={{fontSize: 13, color: "#000", fontWeight: 600}} />
								) : (
									<span style={{fontWeight: 600}}>User #{notification?.sent_by}</span>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const isLikeNotification = selectedNotification?.type === "like";
	const isUpliftNotification = selectedNotification?.type === "uplift" || selectedNotification?.table === "uplift";
	const isReplyNotification = selectedNotification?.table === "comment" || (selectedNotification?.title || "").toLowerCase().includes("reply");

	const getRatingColor = (rating) => {
		if (rating >= 4) return "rating-excellent";
		if (rating >= 3) return "rating-good";
		if (rating >= 2) return "rating-fair";
		return "rating-poor";
	};

	const getStatusBadge = (isHistoric, adminFlagged) => {
		if (adminFlagged) {
			return <span className="badge badge-danger">Flagged</span>;
		}
		return isHistoric ? <span className="badge badge-warning">Historic</span> : <span className="badge badge-success">Fresh</span>;
	};

	const getReplyTypeBadge = (commentType) => {
		if (commentType === undefined || commentType === null) return null;
		return commentType ? <span className="badge badge-success">📍 Zipcode</span> : <span className="badge badge-warning">🏘️ Street</span>;
	};

	const renderUpliftNotificationContent = (notification) => {
		const details = notification?.details;
		if (!details) {
			return (
				<div className="no-ratings" style={{padding: "32px 0"}}>
					<h3>Uplift details not available</h3>
					<p>This uplift does not have enough data to display.</p>
				</div>
			);
		}

		const address = details?.address?.full_address || "N/A";
		const jobIssues = Array.isArray(details?.job_issues) ? details.job_issues : [];
		const stars = details?.stars ? Number(details.stars) : null;
		const jobDate = details?.job_date;
		const likedBy = details?.user;

		return (
			<div className="ratings-grid" style={{marginTop: 0}}>
				<div className="rating-card">
					<div className="rating-card-header">
						<div className="address-info">
							<h4 className="job-address">{address}</h4>
							<div className="rating-info">
								<div className="item-type-badge">
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
										<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
									</svg>
									<span>Uplifted Rating</span>
								</div>
								{jobDate && <span className="comment-date">{moment(jobDate).format("MMM DD, YYYY")}</span>}
							</div>
						</div>
					</div>

					<div className="rating-card-body">
						{stars && (
							<div className="rating-display">
								<div className={`rating-stars ${getRatingColor(stars)}`}>
									{[...Array(5)].map((_, index) => (
										<span key={index} className={`star ${index < stars ? "filled" : ""}`}>
											★
										</span>
									))}
									<span className="rating-number">({stars}/5)</span>
								</div>
								{jobIssues.length > 0 && (
									<div className="issues-list">
										{jobIssues.slice(0, 2).map((issue, index) => (
											<span key={index} className="issue-tag">
												{issueLabels[issue] || issue.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
											</span>
										))}
										{jobIssues.length > 2 && <span className="issue-tag more">+{jobIssues.length - 2} more</span>}
									</div>
								)}
							</div>
						)}

						<div className="job-details">
							{jobDate && (
								<div className="detail-item">
									<span className="detail-label">Job Date:</span>
									<span className="detail-value">{moment(jobDate).format("MMM DD, YYYY")}</span>
									<span className="days-ago">({moment().diff(moment(jobDate), "days")} days ago)</span>
								</div>
							)}
							<div className="detail-item">
								<span className="detail-label">Status:</span>
								<span className="detail-value">{getStatusBadge(details?.is_historic, details?.admin_flagged)}</span>
							</div>
						</div>
					</div>

					<div className="rating-card-footer">
						<div className="item-meta">
							<div className="meta-item issue-tag">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
									<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
									<circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
								</svg>
								<span className="d-flex">
									By
									<CustomUserName user={likedBy} code sx={{fontSize: 13, color: "#000", fontWeight: 600, marginLeft: "4px"}} />
								</span>
							</div>
							<div className="meta-item">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
									<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" />
								</svg>
								<span>Uplifted</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const renderReplyNotificationContent = (notification) => {
		const details = notification?.details;

		if (!details) {
			return (
				<div className="no-ratings" style={{padding: "32px 0"}}>
					<h3>Reply details not available</h3>
					<p>This reply does not have enough data to display.</p>
				</div>
			);
		}

		const reply = details.reply;
		const parentComment = details.parentComment;
		const address = parentComment?.addresses || reply?.addresses || "Reply Details";
		const commentText = reply?.description || "";
		const submittedDate = reply?.createdAt || reply?.updatedAt;
		const status = reply?.is_historic ? "historic" : "fresh";
		const flagged = reply?.admin_flagged;

		return (
			<div className="ratings-grid" style={{marginTop: 0}}>
				<div className={`rating-card ${flagged ? "flagged" : ""}`}>
					{flagged && (
						<div className="m-4 mb-0 text-danger" style={{fontSize: "12px"}}>
							This comment has been flagged by the admin. Please contact the admin for clarification.
						</div>
					)}

					<div className="rating-card-header">
						<div className="address-info">
							<h4 className="comment-address">{address}</h4>
							<div className="rating-info">
								{getStatusBadge(status === "historic", flagged)} {getReplyTypeBadge(reply?.comment_type)}
							</div>
						</div>
					</div>

					<div className="rating-card-body">
						{parentComment && (
							<div className="comment-details">
								<div className="detail-item">
									<span className="detail-value">{parentComment?.addresses?.substring(0, 120)}</span>
								</div>
								{/* <div className="detail-item">
									<span className="detail-label">Comment Reply to:</span>
									<span className="detail-value">{parentComment?.description?.substring(0, 120)}</span>
								</div> */}
								<div className="detail-item">
									<span className="detail-label">Comment Owner:</span>
									<span className="detail-value">
										<CustomUserName user={parentComment?.user} />
									</span>
								</div>
							</div>
						)}

						{parentComment?.description && (
							<div className="comment-description">
								<p>{parentComment?.description?.length > 120 ? `${parentComment?.description?.substring(0, 120)}...` : parentComment?.description}</p>
							</div>
						)}
					</div>

					<div className="rating-card-footer">
						<div className="footer-left">
							<span className="submitted-date">Submitted: {submittedDate ? moment(submittedDate).format("MMM DD, YYYY") : "N/A"}</span>
						</div>
					</div>

					{/* Show all sub-comments (replies) in a list */}
					{details?.allReplies && details.allReplies.length > 0 && (
						<div style={{borderTop: "2px solid #eee", paddingTop: "16px", marginTop: "16px", margin: "0px 16px"}}>
							<div style={{marginBottom: "12px"}}>
								<h5 style={{fontSize: "14px", fontWeight: "600", color: "#333", margin: 0}}>All Replies ({details.allReplies.length})</h5>
							</div>
							<div style={{display: "flex", flexDirection: "column", gap: "12px", margin: 5}}>
								{details.allReplies.map((replyItem, idx) => (
									<div
										key={idx}
										style={{
											padding: "5px",
											borderBottom: "1px solid #d7d7d7ff",
										}}>
										<div style={{display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px"}}>
											<CustomUserName user={replyItem?.user} sx={{fontWeight: 900}} />
											<span style={{color: "#666", fontSize: "12px"}}>{moment(replyItem?.createdAt || replyItem?.updatedAt).format("MMM DD, YYYY")}</span>
										</div>
										<div style={{color: "#333", fontSize: "14px", lineHeight: "1.5"}}>{replyItem?.description || "No description"}</div>
									</div>
								))}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	};

	const renderNotificationBody = () => {
		if (isLikeNotification) return renderLikeNotificationContent(selectedNotification);
		if (isUpliftNotification) return renderUpliftNotificationContent(selectedNotification);
		if (isReplyNotification) return renderReplyNotificationContent(selectedNotification);
		return null;
	};

	return (
		<div className="dashboard-page">
			<div className="page-header">
				<h2>Notifications</h2>
				<p>Stay updated with important alerts and system messages</p>
			</div>

			{/* Notification Controls */}
			<div className="notification-controls">
				<div className="controls-left">
					<div className="notification-stats">
						<span className="total-count">{notificationsList.length} total</span>
						<span className="unread-count">{getUnreadCount()} unread</span>
					</div>

					<div className="filter-controls">
						<select value={activeFilter} onChange={(e) => setActiveFilter(e.target.value)} className="filter-select">
							{getFilterOptions().map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>

						<label className="unread-toggle">
							<input type="checkbox" checked={showOnlyUnread} onChange={(e) => setShowOnlyUnread(!showOnlyUnread)} />
							<span className="checkbox-custom"></span>
							<span className="checkbox-label">Unread only</span>
						</label>
					</div>
				</div>

				<div className="controls-right">
					{getUnreadCount() > 0 && (
						<button className="btn btn-secondary" onClick={() => markAllAsRead(null, true)}>
							Mark All as Read
						</button>
					)}
				</div>
			</div>

			<div className="notifications-container">
				{notificationsList && notificationsList.length > 0 && (
					<div className="notifications-list">
						{notificationsList.map((notification, index) => (
							<div
								key={index}
								onClick={() => handleViewDetails(notification)}
								className={`notification-item cursor-pointer ${notification.is_read ? "unread" : ""} ${getPriorityColor(notification.priority)}`}>
								<div className="notification-content">
									<div className="notification-header">
										<div className={`notification-icon ${getTypeColor(notification.type)}`}>{getNotificationIcon(notification.type)}</div>

										<div className="notification-info">
											<h4 className="notification-title">{notification.title}</h4>
											<div className="notification-meta">
												<span className="notification-time">{formatTimestamp(notification.createdAt)}</span>
												{/* {notification.actionRequired && <span className="action-required">Action Required</span>} */}
												{!notification.is_read && <span className="unread-indicator">New</span>}
											</div>
										</div>

										<div className="notification-controls-item" onClick={(e) => e.stopPropagation()}>
											{!notification.is_read && (
												<button className="btn-icon btn-mark-read" onClick={() => markAsRead(notification.notification_id)} title="Mark as read">
													<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
														<path d="M22 11.08V12A10 10 0 1112 2A10 10 0 0122 11.08Z" stroke="currentColor" strokeWidth="2" />
														<path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" />
													</svg>
												</button>
											)}
											<button className="btn-icon btn-delete" onClick={() => handleDeleteNotification(notification.notification_id)} title="Delete notification">
												<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
													<path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" />
													<path d="M8 6V4A2 2 0 0110 2H14A2 2 0 0116 4V6M19 6V20A2 2 0 0117 22H7A2 2 0 015 20V6H19Z" stroke="currentColor" strokeWidth="2" />
												</svg>
											</button>
										</div>

										<div className="notification-message">{notification?.message}</div>
									</div>
									{/* {notification.recode_data && JSON.parse(notification.recode_data) && <div className="notification-details">{ObjectString({recode_data: notification.recode_data})}</div>} */}
								</div>
							</div>
						))}
					</div>
				)}

				<Drawer
					title={
						<div className="d-flex align-items-center gap-3">
							{selectedNotification && (
								<>
									<div className={`notification-icon ${getTypeColor(selectedNotification.type)}`} style={{width: "48px", height: "48px"}}>
										{getNotificationIcon(selectedNotification.type)}
									</div>
									<div>
										<h3 className="mb-2" style={{fontSize: "1.25rem", fontWeight: 600, color: "#2c3e50", margin: 0}}>
											{selectedNotification.title || "Notification Details"}
										</h3>
										<div className="d-flex align-items-center gap-2 flex-wrap">
											<span className={`badge ${getBootstrapBadgeClass(selectedNotification.type)}`} style={{fontSize: "0.75rem", padding: "0.25rem 0.75rem"}}>
												{selectedNotification.type}
											</span>
											{selectedNotification.table && (
												<span className="badge bg-secondary" style={{fontSize: "0.75rem", padding: "0.25rem 0.75rem"}}>
													{selectedNotification.table}
												</span>
											)}
										</div>
									</div>
								</>
							)}
						</div>
					}
					closable={true}
					onClose={onClose}
					open={open}
					size="large"
					placement="right"
					className="notification-drawer">
					{selectedNotification ? (
						<div className="p-4">
							{/* Status and Metadata Section */}
							<div className="card mb-3">
								<div className="card-body">
									<div className="row g-3">
										<div className="col-md-6">
											<small className="text-muted d-block mb-1" style={{fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.5px"}}>
												Status
											</small>
											<span className={`badge ${selectedNotification.is_read ? "bg-secondary" : "bg-success"}`}>{selectedNotification.is_read ? "Read" : "Unread"}</span>
										</div>
										<div className="col-md-6">
											<small className="text-muted d-block mb-1" style={{fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.5px"}}>
												Created
											</small>
											<div style={{fontSize: "0.95rem", color: "#2c3e50", fontWeight: 500}}>{new Date(selectedNotification.createdAt).toLocaleString()}</div>
										</div>
									</div>
								</div>
							</div>

							{/* Message Section */}
							{selectedNotification.message && (
								<div className="card mb-3">
									<div className="card-body">
										<h5 className="card-title mb-3" style={{fontSize: "1.1rem", fontWeight: 600, color: "#2c3e50", paddingBottom: "0.75rem", borderBottom: "2px solid #e9ecef"}}>
											Message
										</h5>
										<p className="card-text mb-0" style={{color: "#495057", lineHeight: 1.6}}>
											{selectedNotification.message}
										</p>
									</div>
								</div>
							)}

							{/* Details Section */}
							{selectedNotification.details && (
								<div className="card mb-3">
									<div className="card-body">
										<h5 className="card-title mb-3" style={{fontSize: "1.1rem", fontWeight: 600, color: "#2c3e50", paddingBottom: "0.75rem", borderBottom: "2px solid #e9ecef"}}>
											Details
										</h5>
										{renderDetailsSection(selectedNotification.details, selectedNotification.table)}
									</div>
								</div>
							)}

							{/* Record Data Section (if recode_data exists) */}
							{selectedNotification.recode_data && (
								<div className="card mb-3">
									<div className="card-body">
										<h5 className="card-title mb-3" style={{fontSize: "1.1rem", fontWeight: 600, color: "#2c3e50", paddingBottom: "0.75rem", borderBottom: "2px solid #e9ecef"}}>
											Record Data
										</h5>
										{(() => {
											try {
												const recodeData = JSON.parse(selectedNotification.recode_data);
												return <ObjectString recode_data={selectedNotification.recode_data} />;
											} catch (e) {
												return <div className="alert alert-danger mb-0">Unable to parse record data</div>;
											}
										})()}
									</div>
								</div>
							)}

							{/* Actions Section */}
							<div className="d-flex gap-2 pt-3 border-top">
								{!selectedNotification.is_read && (
									<button
										className="btn btn-success d-flex align-items-center"
										onClick={() => {
											markAsRead(selectedNotification.notification_id);
										}}>
										<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: "8px"}}>
											<path d="M22 11.08V12A10 10 0 1112 2A10 10 0 0122 11.08Z" stroke="currentColor" strokeWidth="2" />
											<path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" />
										</svg>
										Mark as Read
									</button>
								)}
								<button
									className="btn btn-danger d-flex align-items-center"
									onClick={() => {
										handleDeleteNotification(selectedNotification.notification_id);
									}}>
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: "8px"}}>
										<path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" />
										<path d="M8 6V4A2 2 0 0110 2H14A2 2 0 0116 4V6M19 6V20A2 2 0 0117 22H7A2 2 0 015 20V6H19Z" stroke="currentColor" strokeWidth="2" />
									</svg>
									Delete Notification
								</button>
							</div>
						</div>
					) : (
						<div className="d-flex align-items-center justify-content-center p-5 text-muted">
							<p className="mb-0">No notification selected</p>
						</div>
					)}
				</Drawer>

				{/* Detail Modal */}
				{showDetailModal && selectedNotification && (
					<div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
						<div className="modal-content" onClick={(e) => e.stopPropagation()}>
							<div className="modal-header">
								<div className="d-flex align-items-center gap-3">
									<div className={`notification-icon ${getTypeColor(selectedNotification.type)}`} style={{width: "48px", height: "48px"}}>
										{getNotificationIcon(selectedNotification.type)}
									</div>
									<div>
										<h3>{selectedNotification.title || "Notification Details"}</h3>
										<div className="d-flex align-items-center gap-2 flex-wrap mt-2">
											<span className={`badge ${getBootstrapBadgeClass(selectedNotification.type)}`} style={{fontSize: "0.75rem", padding: "0.25rem 0.75rem"}}>
												{selectedNotification.type}
											</span>
											{/* {selectedNotification.table && (
												<span className="badge bg-secondary" style={{fontSize: "0.75rem", padding: "0.25rem 0.75rem"}}>
													{selectedNotification.table}
												</span>
											)} */}
											<span className={`badge ${selectedNotification.is_read ? "bg-secondary" : "bg-success"}`} style={{fontSize: "0.75rem", padding: "0.25rem 0.75rem"}}>
												{selectedNotification.is_read ? "Read" : "Unread"}
											</span>
										</div>
									</div>
								</div>
								<button className="modal-close" onClick={() => setShowDetailModal(false)}>
									×
								</button>
							</div>

							<div className="modal-body">
								{renderNotificationBody() || (
									<>
										{/* Status and Metadata Section */}
										<div className="detail-section">
											<h4>Notification Information</h4>
											<div className="detail-grid">
												<div className="detail-item">
													<span className="detail-label">Status:</span>
													<span className="detail-value">
														<span className={`badge ${selectedNotification.is_read ? "bg-secondary" : "bg-success"}`}>{selectedNotification.is_read ? "Read" : "Unread"}</span>
													</span>
												</div>
												<div className="detail-item">
													<span className="detail-label">Created:</span>
													<span className="detail-value">{formatDateTime(selectedNotification.createdAt)}</span>
												</div>
												{selectedNotification.updatedAt && (
													<div className="detail-item">
														<span className="detail-label">Updated:</span>
														<span className="detail-value">{formatDateTime(selectedNotification.updatedAt)}</span>
													</div>
												)}
												{selectedNotification.priority && (
													<div className="detail-item">
														<span className="detail-label">Priority:</span>
														<span className="detail-value">
															<span className={`badge ${getPriorityColor(selectedNotification.priority)}`}>{selectedNotification.priority}</span>
														</span>
													</div>
												)}
											</div>
										</div>

										{/* Message Section */}
										{selectedNotification.message && (
											<div className="detail-section">
												<h4>Message</h4>
												<div className="job-description-full">
													<p>{selectedNotification.message}</p>
												</div>
											</div>
										)}

										{/* Details Section - Rating/Comment Information */}
										{selectedNotification.details && (
											<div className="detail-section">
												<h4>
													{selectedNotification.table === "rating"
														? "Rating Information"
														: selectedNotification.table === "comment" || selectedNotification.table === "street_comment"
															? "Comment Information"
															: "Details"}
												</h4>
												{selectedNotification.details.rating_id && (
													<div className="detail-grid">
														{selectedNotification.details.stars && (
															<div className="detail-item">
																<span className="detail-label">Rating:</span>
																<span className="detail-value">
																	<CustomRatingStar star={Number(selectedNotification.details.stars)} />
																	<span className="ms-2">({selectedNotification.details.stars}/5)</span>
																</span>
															</div>
														)}
														{selectedNotification.details.client_name && (
															<div className="detail-item">
																<span className="detail-label">Client Name:</span>
																<span className="detail-value">{selectedNotification.details.client_name}</span>
															</div>
														)}
														{selectedNotification.details.job_date && (
															<div className="detail-item">
																<span className="detail-label">Job Date:</span>
																<span className="detail-value">{moment(selectedNotification.details.job_date).format("MMM DD, YYYY")}</span>
															</div>
														)}
														{selectedNotification.details.job_issues && Array.isArray(selectedNotification.details.job_issues) && selectedNotification.details.job_issues.length > 0 && (
															<div className="detail-item">
																<span className="detail-label">Job Issues:</span>
																<div className="issues-list-modal">
																	{selectedNotification.details.job_issues.map((issue, idx) => (
																		<span key={idx} className="issue-tag-modal">
																			{issueLabels[issue] || issue.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
																		</span>
																	))}
																</div>
															</div>
														)}
														{selectedNotification.details.description && (
															<div className="detail-item">
																<span className="detail-label">Description:</span>
																<span className="detail-value">{selectedNotification.details.description}</span>
															</div>
														)}
													</div>
												)}
												{selectedNotification.details.street_id && (
													<div className="detail-grid">
														{selectedNotification.details.addresses && (
															<div className="detail-item">
																<span className="detail-label">Address:</span>
																<span className="detail-value">{selectedNotification.details.addresses}</span>
															</div>
														)}
														{selectedNotification.details.description && (
															<div className="detail-item">
																<span className="detail-label">Comment:</span>
																<div className="detail-value">
																	<p>{selectedNotification.details.description}</p>
																</div>
															</div>
														)}
														{selectedNotification.details.comment_date && (
															<div className="detail-item">
																<span className="detail-label">Comment Date:</span>
																<span className="detail-value">{moment(selectedNotification.details.comment_date).format("MMM DD, YYYY")}</span>
															</div>
														)}
														{selectedNotification.details.comment_type !== undefined && (
															<div className="detail-item">
																<span className="detail-label">Type:</span>
																<span className="detail-value">{selectedNotification.details.comment_type ? "📍 Zipcode" : "🏘️ Street"}</span>
															</div>
														)}
													</div>
												)}
												{selectedNotification.details.changes && typeof selectedNotification.details.changes === "object" && (
													<div className="mt-3">
														<h5 style={{fontSize: "1rem", fontWeight: 600, marginBottom: "1rem", color: "#2c3e50", paddingBottom: "0.5rem", borderBottom: "1px solid #e9ecef"}}>Changes</h5>
														<div className="row g-3">
															{Object.entries(selectedNotification.details.changes)
																.filter(([key]) => {
																	// Exclude keys that shouldn't be displayed
																	const excludeKeys = [
																		"rating_id",
																		"street_id",
																		"like_id",
																		"user_id",
																		"addresses_id",
																		"createdAt",
																		"updatedAt",
																		"log_id",
																		"model",
																		"action",
																		"record_id",
																		"ip_address",
																		"parent_street_id",
																		"parent_uplift_id",
																		"manual_id",
																		"place_id",
																		"delete_at",
																		"is_active",
																		"admin_flagged",
																		"admin_edited",
																		"admin_blocked",
																		"deleted",
																		"is_historic",
																		"comment_type",
																		"changes",
																		"password",
																		"status",
																		"verified",
																		"last_name",
																		"first_name",
																		"is_flagged",
																		"is_suspended",
																		"is_contractor",
																		"total_flagged",
																		"total_ratings",
																		"user_uuid",
																		"daily_ratings",
																		"verified_mail",
																		"term_and_policy",
																		"is_google_verified",
																	];
																	return !excludeKeys.includes(key);
																})
																.map(([key, value]) => {
																	if (value === null || value === undefined) return null;
																	const formattedValue = formatDetailsValue(key, value);
																	if (formattedValue === null) return null;
																	return (
																		<div className="detail-item" key={key}>
																			<strong>{getDetailsLabel(key)}:</strong>
																			<span className="detail-value">{formattedValue}</span>
																		</div>
																		// <div key={key} className="detail-item">
																		// 	<span className="detail-label">{getDetailsLabel(key)}:</span>
																		// 	<span className="detail-value">{formattedValue}</span>
																		// </div>
																		// <div key={key} className="col-md-6">
																		// 	<div className="p-3 bg-light rounded border" style={{borderLeft: "3px solid #007bff"}}>
																		// 		<small className="text-muted d-block mb-1" style={{fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600}}>
																		// 			{getDetailsLabel(key)}
																		// 		</small>
																		// 		<div style={{fontSize: "0.95rem", color: "#2c3e50", fontWeight: 500, wordBreak: "break-word"}}>{formattedValue}</div>
																		// 	</div>
																		// </div>
																	);
																})}
														</div>
													</div>
												)}
												{!selectedNotification.details.rating_id && !selectedNotification.details.street_id && !selectedNotification.details.changes && (
													<div className="detail-grid">
														{Object.entries(selectedNotification.details)
															.filter(
																([key]) =>
																	!["is_active", "admin_flagged", "admin_edited", "admin_blocked", "deleted", "is_historic", "createdAt", "updatedAt", "log_id", "model", "action", "record_id", "ip_address"].includes(
																		key,
																	),
															)
															.map(([key, value]) => {
																if (value === null || value === undefined) return null;
																return (
																	<div key={key} className="detail-item">
																		<span className="detail-label">{getDetailsLabel(key)}:</span>
																		<span className="detail-value">{formatDetailsValue(key, value)}</span>
																	</div>
																);
															})}
													</div>
												)}
											</div>
										)}

										{/* Record Data Section */}
										{selectedNotification.recode_data && (
											<div className="detail-section">
												<h4>Record Data</h4>
												{(() => {
													try {
														const recodeData = JSON.parse(selectedNotification.recode_data);
														return <ObjectString recode_data={selectedNotification.recode_data} />;
													} catch (e) {
														return <div className="alert alert-danger mb-0">Unable to parse record data</div>;
													}
												})()}
											</div>
										)}

										{/* Old Record Data Section (for updates) */}
										{selectedNotification.old_recode_data && (
											<div className="detail-section">
												<h4>Previous Record Data</h4>
												{(() => {
													try {
														const oldData = JSON.parse(selectedNotification.old_recode_data);
														return <ObjectString recode_data={selectedNotification.old_recode_data} />;
													} catch (e) {
														return <div className="alert alert-danger mb-0">Unable to parse old record data</div>;
													}
												})()}
											</div>
										)}
									</>
								)}
							</div>

							<div className="modal-footer">
								{!selectedNotification.is_read && (
									<button
										className="btn btn-success d-flex align-items-center"
										onClick={() => {
											markAsRead(selectedNotification.notification_id);
										}}>
										<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: "8px"}}>
											<path d="M22 11.08V12A10 10 0 1112 2A10 10 0 0122 11.08Z" stroke="currentColor" strokeWidth="2" />
											<path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" />
										</svg>
										Mark as Read
									</button>
								)}
								<button
									className="btn btn-danger d-flex align-items-center"
									onClick={() => {
										handleDeleteNotification(selectedNotification.notification_id);
										setShowDetailModal(false);
									}}>
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: "8px"}}>
										<path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" />
										<path d="M8 6V4A2 2 0 0110 2H14A2 2 0 0116 4V6M19 6V20A2 2 0 0117 22H7A2 2 0 015 20V6H19Z" stroke="currentColor" strokeWidth="2" />
									</svg>
									Delete Notification
								</button>
								<button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
									Close
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Notifications;
